import { useEffect, useState } from 'react';
import { IconMicOff } from './Icons';
import { checkMicrophone, hideMediaHelp, mediaHelpSteps, useMediaHelp } from '../lib/mediaHelp';

/** "Microphone is off" — how to allow it on this device, and a button to check again. */
export function MediaHelp() {
  const { open, video } = useMediaHelp();
  const [check, setCheck] = useState<'idle' | 'checking' | 'ok' | 'denied'>('idle');

  useEffect(() => {
    if (!open) return;
    setCheck('idle');
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && hideMediaHelp();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!open) return null;
  const { steps, after } = mediaHelpSteps();
  const recheck = async () => {
    setCheck('checking');
    setCheck((await checkMicrophone()) ? 'ok' : 'denied');
  };

  return (
    <div className="modal-backdrop media-help-backdrop" onClick={hideMediaHelp}>
      <div className="modal media-help" onClick={(e) => e.stopPropagation()} role="dialog" aria-labelledby="media-help-title">
        <div className="media-help-icon">
          <IconMicOff size={28} />
        </div>
        <h2 id="media-help-title">Нет доступа к микрофону</h2>
        <p className="muted">
          {video ? 'Для звонков' : 'Для звонков и голосовых сообщений'} Evo нужен микрофон, а сейчас доступ к нему запрещён. Как
          включить:
        </p>
        <ol className="media-help-steps">
          {steps.map((s) => (
            <li key={s}>{s}</li>
          ))}
        </ol>
        <p className="muted">{after}</p>
        <p className="media-help-tip">
          Чтобы телефон не спрашивал при каждом звонке, в окне запроса выбирайте «Разрешить» или «При использовании приложения», а не
          «Только в этот раз».
        </p>
        {check === 'ok' && <p className="media-help-ok">Доступ к микрофону есть — можно звонить.</p>}
        {check === 'denied' && <p className="media-help-bad">Доступа всё ещё нет.</p>}
        <div className="update-actions">
          <button className="btn primary" onClick={hideMediaHelp}>
            Понятно
          </button>
          <button className="btn ghost" onClick={() => void recheck()} disabled={check === 'checking'}>
            {check === 'checking' ? 'Проверяем…' : 'Проверить доступ'}
          </button>
        </div>
      </div>
    </div>
  );
}
